// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD04pUBO5k7zTsTCQE2MQEX-NeH0jkToK8",
    authDomain: "jeans-store.firebaseapp.com",
    databaseURL: "https://jeans-store.firebaseio.com",
    projectId: "jeans-store",
    storageBucket: "jeans-store.appspot.com",
    messagingSenderId: "479444661396"
  },
  mqtt: {
    hostname: "mqtt.uftw.nz",
    port: 8083,
    path: "/mqtt",
    username: "batou",
    password: "your love is king",
    protocol: "wss"
  }
};
